import React, { useEffect, useState } from "react";
import CallToAction from "../partials/cta";
import CircularProgress from "@mui/material/CircularProgress";
import ErrorMessage from "../partials/error";
import SectionTitle from "../../../components/sectionTitle";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import {
  getRoute,
  getStorageItem,
  setStorageItem,
} from "../../../helpers/utils";
import { isDeclarationProceedButtonDisabled } from "../../../helpers/validation";
import { useHistory } from "react-router";
import {
  BUTTON_ACCEPT_AND_PROCEED,
  BUTTON_DECLINE_DECLARATION,
} from "../../../constants";
import { postWebService } from "../../../helpers/server";

function BuyflowCustomerDeclaration({
  classes: { containerButton, contentScroller, main, loaderBox },
}) {
  const history = useHistory();
  const [errors, setErrors] = useState([]);
  const [modal, setModal] = useState({ open: false });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isLoaded, setIsLoaded] = useState(true);
  const [declaration, setDeclaration] = useState({
    agree: true,
  });
  const declarations = [
    {
      value: "resident",
      title: "I am a Resident Indian and not a Taxpayer outside India.",
    },
    {
      value: "criminal",
      title:
        "I have no criminal history or pending civil / criminal cases, no engagement in any hazardous sports or related activities. Neither me nor my nominee is directly / indirectly a politically exposed persons (PEP).",
    },
    {
      value: "narcotics",
      title:
        "I do not use narcotics or consume more than 10 cigarettes per day and 1 pouch (10 grams) of chewing tobacco, 30 ml hard liquor or 500 ml beer per day.",
    },
  ];
  const checkboxes = [
    {
      value: "agree",
      title: "I have read and hereby agree with the above declarations.",
    },
  ];

  useEffect(() => setIsLoaded(true), []);

  const navigateTo = (pathname) => history.push({ pathname });

  const handleChange = (event) => {
    setDeclaration({
      ...declaration,
      [event.target.name]: event.target.checked,
    });
  };

  const handleBack = () => navigateTo(getRoute("healthAssessment"));

  const cbError = (error = "An error occured, please try again.") => {
    setIsFormSubmitted(false);
    setErrors(new Array(error));
  };

  const updateOrderDetails = async () => {
    try {
      setIsFormSubmitted(true);
      const response = await postWebService("update-order.php", {
        oid: Number(getStorageItem("oid")),
        status: "DECLARATION",
      });

      if (response.data.code === 201) {
        setIsFormSubmitted(false);
        navigateTo(getRoute("guideline"));
      }
    } catch (error) {
      cbError(error);
    }
  };

  const handleClick = () => {
    setIsFormSubmitted(false);
    setStorageItem(
      "journeyCloseReason",
      "Journey terminated as customer has declined to proceed."
    );
    navigateTo(getRoute("terminated"));
  };

  const onSubmit = (event) => {
    event.preventDefault();

    updateOrderDetails();
  };

  return isLoaded ? (
    <Box className={main}>
      <form noValidate autoComplete="off" onSubmit={onSubmit}>
        <Box display="flex" justifyContent="center" m={2} mb={0}>
          <SectionTitle title={"Declarations"} onClickHandler={handleBack} />
        </Box>

        <Box className={contentScroller}>
          <Box textAlign={"left"} p={0.5} mt={2}>
            {declarations.map((item, index) => {
              return (
                <Box
                  key={item.title}
                  flexDirection={"column"}
                  display={"flex"}
                  mb={2}
                >
                  <Typography variant="caption">{item.title}</Typography>
                </Box>
              );
            })}
          </Box>

          <Box className={containerButton}>
            <Box textAlign={"left"} mt={1} mb={1} ml={0.5} mr={0.5}>
              {checkboxes.map((item, index) => {
                return (
                  <Box mt={2} key={`declaration-${index}`}>
                    <FormControlLabel
                      control={
                        <Box style={{ alignSelf: "start" }}>
                          <Checkbox
                            checked={declaration[item.value]}
                            onChange={handleChange}
                            name={item.value}
                            color="primary"
                          />
                        </Box>
                      }
                      label={
                        <Box mt={1}>
                          <Typography variant="caption">
                            {item.title}
                          </Typography>
                        </Box>
                      }
                    />
                  </Box>
                );
              })}
            </Box>

            <ErrorMessage errors={errors} modal={modal} />

            <Box mb={1}>
              <CallToAction
                buttonType={"submit"}
                isFormSubmitted={false}
                text={BUTTON_ACCEPT_AND_PROCEED}
                isDisabled={!declaration.agree}
              />
            </Box>

            <Box>
              <CallToAction
                buttonType={"button"}
                color="decline"
                isFormSubmitted={false}
                handleClick={handleClick}
                text={BUTTON_DECLINE_DECLARATION}
                isDisabled={declaration.agree}
              />
            </Box>
          </Box>
        </Box>
      </form>
    </Box>
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(
  BuyflowCustomerDeclaration
);
